/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { API_SITE, Site_Type, UPLOAD } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { Col, Input, Drawer, Button, Row, message, Popconfirm, Form, Select, Switch, Upload } from 'antd';
import { EditOutlined, DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

function getBase64(img) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.readAsDataURL(img);
  });
}
const Site = ({ translationCache, navigate }) => {
  const [visible, setVisible] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [siteTypeList, setSiteTypeList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [translationCacheState, setTranslationCache] = useState(translationCache || {});
  const [isButtonChecked, setIsButtonChecked] = useState(false);
  const SiteConfigRef = useRef();
  const searchInputRef = useRef();

  useEffect(() => {
    _getSiteList();
    getSiteTypeList();
  }, []);

  useEffect(() => {
    if (translationCache !== translationCacheState) {
      setTranslationCache(translationCache);
    }
  }, [translationCache]);

  const _getSiteList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgHeaders = {
      method: 'GET',
      url: `${API_SITE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setDatasource(response.data);
        setIsButtonChecked(response.data.isChecked);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _getSiteListById = (id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgHeaders = {
      method: 'GET',
      url: `${API_SITE.GET}?SiteId=${siteId}&Id=${id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        setEditObj(response.data && response.data[0] ? response.data[0] : editObj);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSiteTypeList = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgHeaders = {
      method: 'GET',
      url: `${Site_Type.SiteTypeList}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const response = await axios(orgHeaders);
      setSiteTypeList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    if (SiteConfigRef.current) {
      SiteConfigRef.current.resetFields();
    }
    setVisible(true);
    setIsButtonChecked(false);
    setEditObj({});
  };

  const _createSite = () => {
    let values = SiteConfigRef.current.getFieldsValue('Site_form');
    delete values.Id;
    values = {
      ...values,
      OrganizationId: 1,
      ImageURL: ''
    };
    delete values.upload;
    _createSiteAPI(values);
  };

  const _updateSite = (e) => {
    e.preventDefault();
    let values = SiteConfigRef.current.getFieldsValue('Site_form');

    delete values.upload;
    _updateSiteAPI(values);
  };

  const _updateSiteAPI = (updateObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgUpdateHeaders = {
      method: 'PATCH',
      url: `${API_SITE.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(orgUpdateHeaders)
      .then((response) => {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
          _getSiteList();
          setVisible(false);
          setEditObj({});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _createSiteAPI = (data) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const orgCreateHeaders = {
      method: 'POST',
      url: `${API_SITE.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data
    };
    axios(orgCreateHeaders)
      .then(() => {
        _getSiteList();
        setVisible(false);
        
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const onClose = () => {
    if (SiteConfigRef.current) {
      SiteConfigRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const editSite = (editObj) => {
    if (SiteConfigRef.current) {
      SiteConfigRef.current.setFieldsValue(editObj);
    }
    setEditObj(editObj);
    setVisible(true);
    setIsButtonChecked(editObj.VideoCapture);
  };

  const getRoles = (siteId) => {
    navigate({
      pathname: `/rubus/settingsPage/UserManagement/${siteId}/Roles`
    });
  };

  const _deleteSite = (record) => {
    const accessToken = localStorage.get('accessToken');
    const orgDeleteHeaders = {
      method: 'DELETE',
      url: `${API_SITE.DELETE}?Id=${record.Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        SiteId: record.SiteId,
        Id: record.Id
      }
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('Site Deleted');
          _getSiteList();
          setVisible(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const columns = [
    {
      title: translation('Name'),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('Code'),
      dataIndex: 'Code',
      key: 'Code',
      ...getColumnSearchProps('Code')
    },
    {
      title: translation('Address'),
      dataIndex: 'Address',
      key: 'Address',
      ...getColumnSearchProps('Address')
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation('Action'),
      dataIndex: '',
      key: '',
      render: (text, record) => (
        <div>
          {/* {localStorage.get('currentSite') === '0' ? ( */}
          <span>
            <Button
              type="primary"
              onClick={() => editSite(record)}
              style={{ marginRight: '10px' }}
            >
              <EditOutlined />
            </Button>
            <Popconfirm
              title={translation('Are you sure delete Site ?')}
              onConfirm={() => {
                _deleteSite(record);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Button type="primary" style={{ marginRight: '10px' }}>
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </span>
          {/* ) : null} */}
          <Button
            type="primary"
            onClick={() => getRoles(record.Id)}
          >
            {translation('Get Roles')}
          </Button>
        </div>
      )
    }
  ];

  const beforeUpload = (file) => {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJPG) {
      message.error('You can only upload JPG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJPG && isLt2M;
  };

  const handleChange = async (info) => {
    if (info.file.status === 'done') {
      await getBase64(info.file.originFileObj);
      _getSiteListById(editObj.Id);
    }
  };

  return (
    <>
      <Drawer title="Create Site" open={visible} width={600} closable onClose={onClose}>
        <Form
          layout="vertical"
          ref={SiteConfigRef}
          name="Site_form"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label={translation('Upload Logo')}
                name="upload"
                rules={[{ required: true, message: [translation('upload!')] }]}
              >
                <span>
                  <Upload
                    name="logo"
                    disabled={!editObj.Id}
                    listType="picture-card"
                    showUploadList={false}
                    action={`${API_SITE.LogoUpload}?SiteId=${editObj.Id}&SiteOfLogo=${localStorage.get('currentSite')}`}
                    headers={{
                      Authorization: `Bearer ${localStorage.get('accessToken')}`
                    }}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                  >
                    {editObj && editObj.Id && editObj.ImageURL ?
                      <img
                        src={`${UPLOAD.Uploads}/${editObj.ImageURL}`}
                        alt="LOGO"
                        style={{ height: "100%", width: "100%" }}
                      />
                      : "Upload"}
                  </Upload>
                </span>
              </Form.Item>
              <Form.Item
                label="Name"
                name="Name"
                rules={[{ required: true, message: 'Please input your Name!' }]}
              >
                <Input placeholder="Please enter Name"  disabled={editObj.Id} />
              </Form.Item>
              <Form.Item
                label="Id"
                display="none"
                name="Id"
                hidden={true}
                initialValue={editObj.Id || ''}
              >
                <Input style={{ display: 'none' }} disabled={editObj.Id} />
              </Form.Item>
              <Form.Item
                label="Code"
                name="Code"
                rules={[{ required: true, message: 'Please input your Code!' }]}
              >
                <Input placeholder="Please enter Code" disabled={editObj.Id} />
              </Form.Item>
              <Form.Item
                label="Geo Location"
                name="Location"
                rules={[{ required: true, message: 'Please input Geo Location!' }]}
              >
                <Input placeholder="Please enter Geo Location" />
              </Form.Item>
              <Form.Item
                label="Address"
                name="Address"
                rules={[{ required: true, message: 'Please input Address!' }]}
              >
                <Input placeholder="Please enter Address" />
              </Form.Item>
              <Form.Item
                label="Description"
                name="Description"
                rules={[{ required: true, message: 'Please input Description!' }]}
              >
                <Input placeholder="Please enter Description" />
              </Form.Item>
              <Form.Item
                label="Site Type"
                name="SiteType"
                rules={[{ required: true, message: 'Please select Site Type!' }]}
              >
                <Select placeholder="Please select Site Type">
                  {siteTypeList &&
                    Array.isArray(siteTypeList) &&
                    siteTypeList.map((site, index) => (
                      <Option key={index} value={site.Code}>
                        {site.Name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item label="Video Capture" name="VideoCapture">
                <Switch
                  checked={isButtonChecked}
                  onChange={setIsButtonChecked}
                >
                  {isButtonChecked ? 'Checked' : 'Unchecked'}
                </Switch>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <DrawerFooter>
          <Button onClick={onClose} type="primary" style={{ marginRight: 8 }}>
            Cancel
          </Button>
          {!editObj.Id ? (
            <Button type="primary" onClick={_createSite}>
              Create
            </Button>
          ) : (
            <Button type="primary" onClick={_updateSite}>
              Update
            </Button>
          )}
        </DrawerFooter>
      </Drawer>

      {localStorage.get('currentSite') === '0' ? (
        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0px' }}>
          <Button type="primary" onClick={openModal}>
            <PlusOutlined /> Add Site
          </Button>
        </div>
      ) : null}

      <StyledTable size="small"
        columns={columns}
        dataSource={datasource}
        pagination={
          datasource.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
        bordered
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.loggedInProfile,
  };
};

export default connect(mapStateToProps)(Site);